// extracted by mini-css-extract-plugin
module.exports = {"container":"slogon_container__2f_UN","slognImg":"slogon_slognImg__3Lots"};